<p-dialog
  [visible]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: '640px'}"
  [closeOnEscape]="false"
  [dismissableMask]="false"
  [closable]="false"
  [header]="dialogTitle"
  (onHide)="closeDialog()">
  <form [formGroup]="ruleForm" class="rule-form">
    <div class="form-grid form-grid-two">
      <div class="form-row">
        <label>Rule Type</label>
        <p-selectButton formControlName="ruleType" [options]="ruleTypeOptions" optionLabel="label" optionValue="value" (onChange)="onRuleTypeChange()"></p-selectButton>
      </div>
      <div class="form-row">
        <label>Status</label>
        <p-toggle-switch formControlName="status"></p-toggle-switch>
      </div>
    </div>

    <div class="form-grid form-grid-two">
      <div class="form-row">
        <label>Offer Set</label>
        <p-select
          formControlName="offerSetId"
          [options]="eligibleOfferSets"
          optionLabel="title"
          optionValue="id"
          placeholder="Select offer set"
          (onChange)="onOfferSetChange($event.value)"
          [disabled]="isDiscountRule()">
        </p-select>
      </div>
      <div class="form-row">
        <label>Discount Amount</label>
        <p-inputNumber
          formControlName="dollarAmountDiscount"
          mode="currency"
          currency="USD"
          locale="en-US"
          [minFractionDigits]="0"
          [maxFractionDigits]="0"
          [disabled]="!isDiscountRule()">
        </p-inputNumber>
      </div>
    </div>

    <div class="section-divider">Vehicle Criteria</div>

    <div class="form-grid">
      <div class="form-row">
        <label>Condition</label>
        <p-select formControlName="vehicleCondition" [options]="conditionOptions" optionLabel="label" optionValue="value"></p-select>
      </div>
      <div class="form-row">
        <label>Year</label>
        <input pInputText type="number" formControlName="year" />
      </div>
      <div class="form-row">
        <label>Make</label>
        <p-select
          formControlName="makeId"
          [options]="makes"
          optionLabel="displayName"
          optionValue="id"
          placeholder="Select make"
          [filter]="true"
          filterBy="displayName,id"
          [showClear]="true"
          (onChange)="onMakeSelectionChange($event.value)"
          [appendTo]="'body'">
        </p-select>
      </div>
      <div class="form-row">
        <label>Model</label>
        <p-select
          formControlName="modelId"
          [options]="filteredModels"
          optionLabel="name"
          optionValue="id"
          placeholder="Select model"
          [filter]="true"
          filterBy="name,id"
          [showClear]="true"
          (onChange)="onModelSelectionChange($event.value)"
          [disabled]="modelDropdownDisabled"
          [appendTo]="'body'">
        </p-select>
      </div>
      <div class="form-row">
        <label>Trim</label>
        <input pInputText type="text" formControlName="trim" />
      </div>
      <div class="form-row">
        <label>Vehicle Limit</label>
        <input pInputText type="number" formControlName="vehicleLimit" />
      </div>
      <div class="form-row">
        <label>Max Price</label>
        <p-inputNumber
          formControlName="maxSalePrice"
          mode="currency"
          currency="USD"
          locale="en-US"
          [minFractionDigits]="0"
          [maxFractionDigits]="0">
        </p-inputNumber>
      </div>
    </div>
    <div class="dialog-actions">
      <p-button label="Cancel" severity="secondary" (click)="closeDialog()"></p-button>
      <p-button label="Save" severity="success" [disabled]="savingRule" (click)="saveRule()"></p-button>
    </div>
  </form>
</p-dialog>
